import { FC, PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';

/**
 * Keeps form controls in creation-modal content at the platform's regular size.
 * Header and footer controls remain outside this provider so their compact
 * presentation stays consistent across creation flows.
 */
const ResourceCreationModalContent: FC<PropsWithChildren> = ({ children }): JSX.Element => (
    <ConfigProvider componentSize='middle'>{children}</ConfigProvider>
);

export default ResourceCreationModalContent;
